import { stringifyError } from '@/shared/parse';
import { Alert, AlertIcon, HStack, VStack, AlertTitle, Collapse, AlertDescription, Button } from '@chakra-ui/react';
import { AuthService } from '../services/AuthService';
import React from 'react';

export const ErrorMessage = (props: { error: any }) => {

  const [messageVisible, setMessageVisible] = React.useState<boolean>(false);
  const messageRef = React.useRef<any>();
  
  const setError = (error: any) => {
    if (error) {
      const isAuthIssue = typeof error === 'object' && (error.name === 'BrowserAuthError' || error.name === 'InteractionRequiredAuthError' || error.name === 'AuthError');
      if (isAuthIssue) {
        messageRef.current = {
          title: error.title || 'Please login to access this page.',
          description: error.description || 'The user session has expired or does not exist. This page is available only to the authorized users.',
          isAuthorizationIssue: true
        };
      } else {
        messageRef.current = {
          title: error ? stringifyError(error) : '',
          description: error?.internalError ? stringifyError(error?.internalError) : '',
          isAuthorizationIssue: false
        };
      }
      setMessageVisible(true);
    } else {
      setMessageVisible(false);
    }
  }

  React.useEffect(() => setError(props.error), [props.error]);

  const authorize = async () => {
    try {
      await AuthService.loginPopup();
    } catch (error) {
      setError(error);
    }
  }

  return <Collapse in={messageVisible}>
    <Alert my={4} status={messageRef.current?.isAuthorizationIssue ? 'warning' : 'error'}>
      <HStack w='full' align='start'>
        <AlertIcon mt='1' />
        <VStack w='full' align='start' p='0' spacing='0'>
          <AlertTitle>{messageRef.current?.title}</AlertTitle>
          <AlertDescription>{messageRef.current?.description}</AlertDescription>
        </VStack>
        {messageRef.current?.isAuthorizationIssue && <Button onClick={authorize} size='xl' colorScheme='yellow'>Click here to Log In...</Button>}
      </HStack>
    </Alert>
  </Collapse>
};